<template>
  <div v-loading="$wait.waiting(_uid)">
    <print-record :user="user" :records="topics" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrintRecord from "@components/Dashboard/Views/Pages/Training/Record/Components/Print";
import MyService from "@app/services/my";

export default {
  components: {
    PrintRecord,
  },
  data() {
    return {
      topics: [],
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("userStore", { user: "user" }),
    routeQuery() {
      return this.$route.query;
    },
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const records = await MyService.getRecords(this.routeQuery.date);
      this.topics = records.topics;
    } catch (error) {
      this.$wait.end(this._uid);
    } finally {
      setTimeout(window.print, 800);
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
  },
};
</script>

<style lang="scss" scoped></style>
